const css = `/**
 * SCSS Variables.
 *
 * Please use variables from this sheet to ensure consistency across the UI.
 * Don't add to this sheet unless you're pretty sure the value will be reused in many places.
 * For example, don't add rules to this sheet that affect block visuals. It's purely for UI.
 */
/**
 * Colors
 */
/**
 * Fonts & basic variables.
 */
/**
 * Typography
 */
/**
 * Grid System.
 * https://make.wordpress.org/design/2019/10/31/proposal-a-consistent-spacing-system-for-wordpress/
 */
/**
 * Radius scale.
 */
/**
 * Elevation scale.
 */
/**
 * Dimensions.
 */
/**
 * Mobile specific styles
 */
/**
 * Editor styles.
 */
/**
 * Block & Editor UI.
 */
/**
 * Block paddings.
 */
/**
 * React Native specific.
 * These variables do not appear to be used anywhere else.
 */
.style-module__circle-root__j1e41 {
  border-radius: 50%;
  border: 1px solid var(--wp-components-color-gray-600, #949494);
  box-sizing: border-box;
  cursor: grab;
  height: 32px;
  overflow: hidden;
  width: 32px;
}
.style-module__circle-root__j1e41:active {
  cursor: grabbing;
}

.style-module__circle-indicator-wrapper__sbrph {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
}
.style-module__circle-indicator-wrapper__sbrph:focus-visible {
  outline: none;
}

.style-module__circle-indicator__bS-go {
  background: var(--wp-components-color-accent, var(--wp-admin-theme-color, #3858e9));
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  left: 50%;
  top: 4px;
  transform: translateX(-50%);
  position: absolute;
  width: 6px;
  height: 6px;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "circle-root": "style-module__circle-root__j1e41",
  "circle-indicator-wrapper": "style-module__circle-indicator-wrapper__sbrph",
  "circle-indicator": "style-module__circle-indicator__bS-go"
};